import { useState, useCallback } from "react";
import { CategoryButton } from "../types/categories";
import { categoryService } from "./categoryService";

export const useCategories = () => {
  const [categories, setCategories] = useState<CategoryButton[]>([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [error, setError] = useState<string | null>(null);

  const fetchCategories = useCallback(async (showDeleted: boolean, page: number, pageSize: number, searchTerm: string = "") => {
    setLoading(true);
    try {
      const data = await categoryService.fetch(showDeleted, page, pageSize, searchTerm, "displayOrder", "asc");
      setCategories(data.categoryDetails);
      setTotalRecords(data.totalRecords);
    } catch (err) {
      setError("Failed to fetch categories");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchCategoriesQuietly = useCallback(async (showDeleted: boolean, page: number, pageSize: number, searchTerm: string = "") => {
    try {
      const data = await categoryService.fetch(showDeleted, page, pageSize, searchTerm, "displayOrder", "asc");
      setCategories(data.categoryDetails);
      setTotalRecords(data.totalRecords);
    } catch (err) {
      console.error("Error quietly fetching categories:", err);
    }
  }, []);

  const reorderCategoriesLocally = useCallback((sourceIndex: number, targetIndex: number, page: number = 0, rowsPerPage: number = 10) => {
    setCategories((prev) => {
      const updated = [...prev];
      const [moved] = updated.splice(sourceIndex, 1);
      updated.splice(targetIndex, 0, moved);
      return updated.map((cat, idx) => ({
        ...cat,
        displayOrder: page * rowsPerPage + idx + 1,
      }));
    });
  }, []);

  return {
    categories,
    loading,
    totalRecords,
    error,
    fetchCategories,
    fetchCategoriesQuietly,
    reorderCategoriesLocally,
    setCategories,
  };
};
